import { CsbHelper } from '@recruiting-solutions/rs-shared';

export abstract class ArvBaseTrackingService {
    static readonly PREFIX = 'arvato';

    init(): void {}

    protected getDefaults() {
        const locale = CsbHelper.getLocale();
        return {
            pageLanguage: locale,
            pagePath: window.location.href,
            pageTitle: document.title,
        };
    }

    protected pushToGtag(name: string, properties: { [key: string]: any }) {
        const defaults = this.getDefaults();
        properties = { ...properties, ...defaults };
        const dataLayer = ((window as any).dataLayer = (window as any).dataLayer || []);

        this.log(properties);
        dataLayer.push({ event: name, ...properties });
    }

    private log(properties: { [key: string]: any }) {
        const strippedProps = { ...properties };
        delete strippedProps.eventName;
        delete strippedProps.severityLevel;
        console.log(
            `sent to gtag %c${properties.eventName}\n%c${JSON.stringify(strippedProps)}`,
            'background: #444; color: #bada55; padding: 2px; border-radius:2px',
            'background: #fff; color: red; padding: 2px;',
        );
    }
}
